import React, { useEffect, useState } from 'react';
import './ValidationReferencesMultipleProviders.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import { IFileRowMultipleProviders } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';
import CURRENCY from 'utils/constants/currency';
import Pagination from 'components/pagination/Pagination';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';

import { notify } from 'utils/marketplace';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};

const ValidationReferencesMultipleProviders: React.FC<Props> = (props) => {

  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  const user = JSON.parse(localStorage.getItem('userData')!);
  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [data, setData] = useState<IFileRowMultipleProviders[]>([]);
  const [dataPagination, setDataPagination] = useState<Array<IFileRowMultipleProviders>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(2);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [referenceMultipleProviders, setReferenceMultipleProviders] = useState<Record<string, string>>({});

  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesMultipleProviders') {
      const referenceMultipleProviders = proformaFile?.rows?.filter((row) => row.section === 'REFERENCE_MULTIPLE_PROVIDERS') || [];

      const updatedReferences = referenceMultipleProviders.reduce((acc, row) => {
        const minPriceItem = row.info.reduce((min, item) => {
          return (min === null || (item.current_aol_price !== undefined && item.current_aol_price < min.current_aol_price))
            ? item
            : min;
        }, null);

        if (minPriceItem) {
          acc[row.data[4] + '-' + row.data[0]] = `${minPriceItem.reference}-${minPriceItem.codfou}-${row.data[0]}`;
        }

        return acc;
      }, {});

      setReferenceMultipleProviders(prev => ({
        ...prev,
        ...updatedReferences
      }));

      setData(referenceMultipleProviders);
    }

  }, [props.stepModalNext]);

  useEffect(() => {
    if (data.length > 0) {

      const total = data.length;

      setTotalPages(Math.ceil(total / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setDataPagination(data.slice(startIndex, endIndex));
    }


  }, [data, currentPage, itemsPerPage]);

  const handlePageClick = (page: number) => {
    setCurrentPage(page);

  };

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    referenceKey: string
  ) => {
    const { value, checked } = e.target;

    setReferenceMultipleProviders(prev => {
      const updated = { ...prev };

      if (checked) {
        updated[referenceKey] = value;
      } else if (updated[referenceKey] === value) {
        delete updated[referenceKey];
      }

      return updated;
    });
  };


  const handleSubmit = () => {


    if (Object.keys(referenceMultipleProviders).length < data.length) {
      notify(t('_error_validated_all_references'), 'error', t('_error'));

      return;
    }

    const referenceNotSElected: Array<{ reference: string; codfou: string }> = [];

    data.map((row) => {
      row.info.forEach((item) => {
        if (referenceMultipleProviders[String(row.data[4] + '-' + row.data[0])] !== item.reference + '-' + item.codfou + '-' + row.data[0]) {
          referenceNotSElected.push({ reference: item.reference, codfou: item.codfou });
        }
      });
    });

    setTimeout(() => {
      const partsWithReplacements = proformaFile.partsWithReplacements || [];

      // const updatedData = partsWithReplacements.map((item) => {
      //   const updatedParts = item.parts.filter((part) =>

      //     !referenceNotSElected.some((ref) => ref.reference.replace(/^0+|[^a-zA-Z0-9]/g, '') === part.reference.replace(/^0+|[^a-zA-Z0-9]/g, '') && ref.codfou === part.codfou)

      //   );

      //   return { ...item, parts: updatedParts };
      // });

      const updatedData = partsWithReplacements.map((item) => {
        const updatedParts = item.parts.filter((part) =>
          !referenceNotSElected.some((ref) => {

            const referenceToCompare = part.replace_status ? part.replace.reference : part.reference;
            const codfouToCompare = part.replace_status ? part.replace.codfou : part.codfou;

            return (
              ref.reference.replace(/^0+|[^a-zA-Z0-9]/g, '') === referenceToCompare.replace(/^0+|[^a-zA-Z0-9]/g, '') && ref.codfou === codfouToCompare
            );
          })

        );

        return { ...item, parts: updatedParts };
      });

      const referencesFiltred = proformaFile.rows?.filter((row) => row.section !== 'REFERENCE_MULTIPLE_PROVIDERS');

      localStorage.setItem('proformaFileInProgress', JSON.stringify({
        ...proformaFile,
        rows: referencesFiltred,
        partsWithReplacements: updatedData.filter((item) => item.parts.length !== 0)
      }));


      props.setStepModal('CustomerOrderReferenceReplace');
    }, 0);


  };

  return (
    <div className="validation-custumer-order-multiple-providers-modal" >
      <div className="close upload_order_info_multiple-providers_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>
      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_warning_multiple_providers')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_multiple_providers"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">
          <table className="validation-customer-modal-table">
            <thead>
              <tr>
                <th className="text-align-left" style={{ width: '20%' }} >
                  {t('_reference')}
                </th>
                <th style={{ width: '80%' }} >
                  <div className="providers-modal-row">
                    {t('_search_result')}
                    <div className="info">
                      <div className="reference">
                        {t('_reference')} / {t('_description')}
                      </div>
                      <div className="brand">
                        {t('_brand')}
                      </div>
                      <div className="price">
                        {t('_price')}
                      </div>
                      <div className="checkbox">

                      </div>
                    </div>

                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                dataPagination.map((row, index) => (
                  <tr key={`${row.data[4]}-${index}`}>
                    <td className="text-align-left">{row.data[4]}</td>
                    <td>
                      <div className={`providers-modal-row  ${referenceMultipleProviders[String(row.data[4] + '-' + row.data[0])] ? 'green' : 'red'}`}>
                        {
                          row.info.map((item, idx: number) => (
                            <div key={`${item.reference}-${idx}`} className="providers-modal-info">
                              <div className="info">

                                <div className="reference">
                                  {item.reference}  {item.description ? '/ ' + item.description : ''}
                                </div>

                                <div className="brand" >
                                  <div className="brand-logo">

                                    <img src={item.supplier_logo} onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src = '/images/car-part-placeholder-big.png';
                                    }} alt="provider-logo" height={24}
                                    />
                                  </div>
                                  <div className="brand-name">
                                    {item.supplier_name}
                                  </div>


                                </div>
                                <div className="price">
                                  {item.current_aol_price ? `${item.current_aol_price} ${CURRENCY[user!.currency]}` : '-'}

                                </div>
                              </div>
                              <div className="checkbox">

                                <input
                                  type="checkbox"
                                  value={item.reference + '-' + item.codfou + '-' + row.data[0]}
                                  id={item.reference + item.codfou}
                                  onChange={(e) => handleCheckboxChange(e, String(row.data[4] + '-' + row.data[0]))}
                                  checked={
                                    referenceMultipleProviders[String(row.data[4] + '-' + row.data[0])] === item.reference + '-' + item.codfou + '-' + row.data[0]
                                  }
                                />


                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </td>


                  </tr>)))
                :
                <tr>
                  <td colSpan={2} className="no-data">{t('_no_data')}</td>
                </tr>
              }


            </tbody>
          </table>
          {
            totalPages > 1 && (
              <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
            )
          }
        </div >

        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn upload_order_info_dublicate" text={t('_send_the_order_for_processing')} onClick={() => { handleSubmit(); }} />

            <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_dublicate_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

          </div>

        </div>

      </div >
    </div >
  );

};

ValidationReferencesMultipleProviders.displayName = 'ValidationReferencesMultipleProviders';

export default ValidationReferencesMultipleProviders;